module.exports = __webpack_public_path__ + "img/Weapon_172.bc95b9a5.png";